
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalPluggedNoChargeEmpty as ObiBatteryHorizontalPluggedNoChargeEmptyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-plugged-no-charge-empty.js';
 
 
 

 
 export const ObiBatteryHorizontalPluggedNoChargeEmpty = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-plugged-no-charge-empty',
   elementClass: ObiBatteryHorizontalPluggedNoChargeEmptyElement,
   events: {
     
   }
  });
 
 